module.exports = __webpack_public_path__ + "static/media/  (28).f61aa9b3.jpg";